import React from 'react';

export function Spinner({ text = "Bitte warten..." }) {
  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      zIndex: 10000,
      background: 'rgba(255,255,255,0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        padding: 30,
        background: '#fff',
        borderRadius: 10,
        boxShadow: '0 4px 24px #0002',
        textAlign: 'center'
      }}>
        <div className="loader" style={{
          width: 42, height: 42, margin: '0 auto 18px',
          border: '5px solid #1e88e5',
          borderTop: '5px solid #fff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <div style={{ fontSize: 18, color: '#1e88e5' }}>{text}</div>
        <style>
          {`@keyframes spin { 0% {transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}
        </style>
      </div>
    </div>
  );
}
